import React from 'react'
import { Modal } from '@arnsbogroup/react-voicearchive'
import NiceModal, { useModal } from '@ebay/nice-modal-react'

export default NiceModal.create(({ src }) => {
    const modal = useModal()

    return (
        <Modal
            show={modal.visible}
            onClose={() => modal.remove()}
            onOutsideClick={() => modal.remove()}
            title="Studio setup"
            dialogPanelClasses="max-w-screen-xl overflow-x-scroll"
        >
            <img 
                src={src} 
                alt="Studio setup Preview"
                className='w-full h-auto'
            />
        </Modal>
    )
})
